import { Subscription } from "rxjs";
import { modal$ } from "../lib/state";
import { ModalContentType } from "../lib/types";

class BuilderModal extends HTMLElement {
  #NAME = 'BuilderModal'
  #abortController: AbortController | null = null
  #sub?: Subscription
  #contentType?: ModalContentType
  #closeBtn: HTMLButtonElement
  #content: HTMLDivElement
  #innerContent: HTMLDivElement

  constructor() {
    super();
    this.#closeBtn = this.querySelector('button[title="close"]') as HTMLButtonElement;
    this.#content = this.querySelector('div[data-content]') as HTMLDivElement;
    this.#innerContent = this.querySelector('div[data-inner-content]') as HTMLDivElement;
  }

  connectedCallback(): void {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.#closeBtn.addEventListener('click', () => modal$.next({ show: false }), { signal });
    //
    this.#sub = modal$.subscribe(dta => {
      if (dta.contentType) {
        this.dataset.contentType = dta.contentType;
      }
      this.dataset.show = dta.show.toString();
        if (!dta.show) location.hash = '';
    });
  }

  disconnectedCallback(): void {
    this.#abortController?.abort();
    this.#abortController = null;
    this.#sub?.unsubscribe();
  }

  static get observedAttributes(): string[] {
    return ['data-content-type'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    //
    if (name === 'data-content-type') {
      this.#contentType = newValue as ModalContentType;
      this.#content.className = this.#contentType;
      const template: HTMLTemplateElement | null = document.querySelector(`template#${this.#contentType}`);
      if (template) {
        this.#innerContent.innerHTML = template.innerHTML;
      }
    }
  }
}

customElements.define('builder-modal', BuilderModal);